import { RefObject } from "react"
import { TourStep } from "../Tour"

export interface InventorySvedCreatorTourRefs {
    inventoryDateTime: RefObject<HTMLDivElement>
    storeSelection: RefObject<HTMLDivElement>
    inventoryType: RefObject<HTMLDivElement>
    comment: RefObject<HTMLDivElement>
    vedSelection: RefObject<HTMLDivElement>
    itemsGrid: RefObject<HTMLDivElement>
    itemCommands: RefObject<HTMLDivElement>
    totalsAccordion: RefObject<HTMLDivElement>
}

export const getInventorySvedCreatorTourSteps = (refs: InventorySvedCreatorTourRefs): TourStep[] => [
    {
        target: () => refs.inventoryDateTime.current,
        description: "Заполняем дату и время инвентаризации. При полной инвентаризации документы с более ранней датой нельзя будет изменить",
        placement: "bottom",
    },
    {
        target: () => refs.storeSelection.current,
        description: "Заполняем аптеку и склад, по которому была проведена инвентаризация",
        placement: "bottom",
    },
    {
        target: () => refs.inventoryType.current,
        description: (
            <div>
                Инвентаризация может быть полной, либо частичной.
                <br />
                Если инвентаризация частичная, то будет учитываться изменение только тех партий, которые попали в инвентаризационные ведомости.
                <br />
                Если инвентаризация полная, то партии этого склада, не попавшие ни в одну ведомость, будут списаны.
            </div>
        ),
        placement: "bottom",
    },
    {
        target: () => refs.comment.current,
        description: "Здесь можно оставить комментарий к сводной инвентаризации",
        placement: "top",
    },
    {
        target: () => refs.vedSelection.current,
        description: "Подбор ведомостей в сводную инвентаризацию осуществляется через строку подбора",
        placement: "top",
    },
    {
        target: () => refs.itemsGrid.current,
        description: "В этой таблице отображаются все добавленные в сводную инвентаризацию ведомости",
        placement: "top",
    },
    {
        target: () => refs.itemCommands.current,
        description: (
            <div>
                Кнопки управления позициями документа:
                <ul>
                    <li>Обновить - обновляет таблицу</li>
                    <li>Удалить - удаляет выделенную позицию</li>
                    <li>Очистить - удаляет все позиции в документе</li>
                </ul>
            </div>
        ),
        placement: "bottom",
    },
    {
        target: () => refs.totalsAccordion.current,
        description: "При развёрнутом аккордеоне отображается информация о суммах всех инвентаризационных ведомостей, добавленных в сводную инвентаризацию",
        placement: "top",
    },
]
